export const CASCADED_ACCOUNTS_RESET_STATE = 'CASCADED_ACCOUNTS_RESET_STATE';
export const CASCADED_ACCOUNTS_CURRENT_ITEM = 'CASCADED_ACCOUNTS_CURRENT_ITEM';

export const CASCADED_ACCOUNTS_REQUEST_LOADING = 'CASCADED_ACCOUNTS_REQUEST_LOADING';
export const CASCADED_ACCOUNTS_REQUEST_SUCCESS = 'CASCADED_ACCOUNTS_REQUEST_SUCCESS';
export const CASCADED_ACCOUNTS_REQUEST_FAILED = 'CASCADED_ACCOUNTS_REQUEST_FAILED';

export const CASCADED_ACCOUNTS_CURRENT_ACTION = 'CASCADED_ACCOUNTS_CURRENT_ACTION';
export const CASCADED_ACCOUNTS_RESET_ACTION = 'CASCADED_ACCOUNTS_RESET_ACTION';